"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=menu-item.decl.js.map